// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"45547":"color-preview","87594":"about"}[chunkId] + "." + {"45547":"de396232","87594":"ccc566a2"}[chunkId] + ".css";
};